import { useSessionStore } from '@/stores/SessionStore.ts';
import { WS_REQUEST } from '@/types/ws/WebSocketEvents.ts';
import { WebSocketService } from '@/ws/WebSocketService.ts';
import type { SyncTarget } from '@/types/sync/SyncTarget.ts';
import type { SYNC_TO_WEB_VIEW_KEYS } from '@/types/sync/SyncKeys.ts';
import { v4 as uuidv4 } from 'uuid';

export const syncToWebViewAction = (key: SYNC_TO_WEB_VIEW_KEYS, value: string): void => {
    const sessionStore = useSessionStore();
    if (sessionStore.isInsideWebView) {
        throw new Error('syncToWebViewAction should not be called from inside the web view');
    }

    const target: SyncTarget = 'web-view';

    WebSocketService.instance.send(WS_REQUEST.sync_clientSync, {
        id: uuidv4(),
        target: target,
        key: key,
        value: value,
    });
};
